import { forwardRef } from "react";
import * as SelectPrimitive from "@radix-ui/react-select";

import type {
  TSelectSeparatorElement,
  TSelectSeparatorProps,
} from "@/ui/components/form/Select/Select.config";
import { cn } from "@/ui/lib/utils";

export const SelectSeparator = forwardRef<TSelectSeparatorElement, TSelectSeparatorProps>(
  (
    {
      className,
      ...props
    },
    ref,
  ) => (
    <SelectPrimitive.Separator
      data-component="SelectSeparator"
      ref={ref}
      className={cn("-mx-1 my-1 h-px bg-border-primary", className)}
      {...props}
    />
  ),
);

SelectSeparator.displayName = SelectPrimitive.Separator.displayName;
